import { View } from 'backbone.marionette';
import Radio from 'backbone.radio';

const joinChannel = Radio.channel( 'join' );

export default class CoreLeagueJoinBarView extends View {
	get template() {
		throw new Error( "Need set template for child CoreLeagueJoinBarView class" );
	}

	get className() {
		return "";
	}

	/**
	 * Set all UI for this view
	 * @returns object
	 */
	ui() {
		return {
			join_league_by_pin:   '.js-join-league-by-pin',
			search_league_by_pin: '.js-search-league-by-pin',
			league_pin:           '.js-league-code'
		};
	}

	/**
	 * Create events for this UI
	 * @returns object
	 */
	events() {
		return {
			'click @ui.join_league_by_pin':   'joinLeagueByPin',
			'click @ui.search_league_by_pin': 'searchLeagueByPin'
		};
	}

	searchLeagueByPin() {
		let code = this.getUI( 'league_pin' ).val();
		joinChannel.trigger( 'search:by:pin:league', code );
	}

	joinLeagueByPin() {
		let code = this.getUI( 'league_pin' ).val();
		joinChannel.trigger( 'join:to:league', code );
	}
}